module.exports = __webpack_public_path__ + "static/media/dvd-img.0142d9f3.png";